import { z } from "zod";

export interface ProductCatalogApiConfig {
	baseUrl: string;
}

export function loadProductCatalogApiConfig(): ProductCatalogApiConfig {
	const env = validateEnvironment();
	return {
		baseUrl: env.PRODUCT_CATALOG_API
	};
}

function validateEnvironment() {
	const envSchema = z.object({
		PRODUCT_CATALOG_API: z.string({
			required_error:
				"PRODUCT_CATALOG_API environment variable is missing"
		})
	});

	const parsed = envSchema.safeParse(process.env);

	if (!parsed.success) {
		throw new Error(parsed.error.errors.map((e) => e.message).join("\n"));
	}

	return parsed.data;
}
